import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';
import { HttpParams } from '@angular/common/http';
import { WaiverRequestFilter } from 'src/app/shared/models/waiverrequestFilter.model';
import { FrontOfficeRequestFilter } from 'src/app/shared/models/frontofficerequestFilter.model';

@Injectable({ providedIn: 'root' })
export class FrontOfficeRequestService {
    constructor(private dataService: DataService) { }

    public get(page: number, order: string, orderT: string, filter: FrontOfficeRequestFilter) {
        let body = {
            entity: {
                startDate: filter.startDate,
                endDate: filter.endDate,
                defined: filter.defined ? "S" : "N",
                neg: filter.neg,
                frontOffice: filter.frontOffice,
                credit: filter.credit,
                bank: filter.bank,
                popId: '*',
            },
            page: page,
            orderByField: order,
            orderBy: orderT,
        };

        return this.dataService.post<Result<any>>("frontofficesrequests", body);
    }

    public getNegs() {
        return this.dataService.get<Result<any>>('neg');
    }
}
